import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { StoryElement } from "@quintype/components";

import DatawrapperEmbed from "../DatawrapperEmbed";

import './EmbedElement.m.css';

const EmbedElement = ({ element, story }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!element || !element.type) return null;

  if (element.type === "jsembed") {
    return <DatawrapperEmbed element={element} story={story} />;
  }

  return (
    <div styleName="story-element">
      {isMounted && <StoryElement element={element} story={story} />}
    </div>
  );
};

EmbedElement.propTypes = {
  element: PropTypes.object.isRequired,
  story: PropTypes.object.isRequired,
};

export default EmbedElement;
